import React from "react"

function LoadingVisual(props) {
    return (
        <div>
            <img id="loadingKey" src={"images/icons/loadingKey.png"} alt="a key" />
            <h1>LOADING...</h1>
        </div>
    )
}

export default LoadingVisual